import React, { Component } from 'react';
import NavigateIcon from '../../../components/NavigateIcon';
import DisplayAndCreate from '../../../components/DisplayAndCreate';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button';
import { fetchContent, importContentCsv } from '../../../apis/MenuContentAPI';
import Loading from '../../../components/Loading';
import ErrorMessage from '../../../components/ErrorMessage';
import { Link } from 'react-router-dom';
import Edit from '@material-ui/icons/Edit';
import MUIDataTable from 'mui-datatables';
import Tooltip from '@material-ui/core/Tooltip';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Header from '../../../components/HomeNavigation';
import NavigationLayout from '../../../components/Layouts/NavigationLayout';
import CopyMoveToChannelModal from '../../../components/CopyMoveToChannelModal';
import ImportContentModal from '../../../components/ImportContentModal';
import { connect } from 'react-redux';
import {
  copyGFCBrand,
  moveGFCBrand
} from '../../../redux/actions/GroupActions';
import { enqueueSnackbar } from '../../../redux/actions/SnackbarActions';
import { fetchGroup } from '../../../apis/GroupAPI';

const styles = {
  header: {
    margin: '10px 0 10px'
  },
  tableCellPadding: {
    padding: '0px 0px 0px 0px'
  },
  noHover: {
    background: 'transparent'
  },
  searchbox: {
    display: 'table-cell',
    width: '40%'
  },
  notes: {
    marginTop: '18px'
  },
  search: {
    left: '400px',
    position: 'relative'
  },
  tableheader: {
    width: '30%'
  },
  searchIcon: {
    marginTop: '-35px',
    marginLeft: '160px'
  },
  searchInput: {
    marginTop: '-28px'
  },
  iconfont: {
    fontSize: '0.75rem',
    display: 'inline-block',
    position: 'absolute'
  },
  main: {
    marginLeft: '100px',
    marginRight: '100px'
  }
};

const RowOptions = ({ path, id }) => (
  <div style={{ float: 'right', minWidth: '100 px' }}>
    <Link to={path} id={id}>
      <Tooltip title="Edit" placement="top">
        <IconButton>
          <Edit />
        </IconButton>
      </Tooltip>
    </Link>
  </div>
);

const BASE_10_RADIX = 10;
const noContent = 'No content has been added for this group';

export class GroupContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      anchorEl: null,
      items: null,
      brandId: null,
      sourceChannelId: null,
      copyMoveModalOpen: false,
      importModalOpen: false,
      importing: false,
      importErrors: []
    };
  }

  componentDidMount = async () => {
    await this.initialise();
  };

  componentDidUpdate(prevProps) {
    const {
      copying,
      copySuccess,
      copyError,
      moving,
      moveSuccess,
      moveError
    } = this.props;

    this.handleOperationResult(
      prevProps.copying,
      copying,
      copySuccess,
      copyError,
      'copy'
    );
    this.handleOperationResult(
      prevProps.moving,
      moving,
      moveSuccess,
      moveError,
      'move'
    );
  }

  handleOperationResult = (wasInProgress, inProgress, success, error, verb) => {
    if (!(wasInProgress && !inProgress)) {
      return;
    }
    if (success) {
      const pastTense = verb === 'copy' ? 'copied' : 'moved';
      this.props.enqueueSnackbar({
        message: `Group successfully ${pastTense} to channel!`,
        options: { variant: 'success' }
      });
      this.setState({ copyMoveModalOpen: false });
      this.props.history.push(
        `/channel/${this.props.match.params.channelId}/groups`
      );
    } else if (error) {
      this.props.enqueueSnackbar({
        message: `Failed to ${verb} group. Please try again.`,
        options: { variant: 'error' }
      });
    }
  };

  initialise = async () => {
    const { match } = this.props;

    try {
      const items = await fetchContent(match.params.groupName);
      this.setState({ items });
    } catch (error) {
      this.setState({ error: true });
    }

    this.loadBrandId();
  };

  loadBrandId = async () => {
    const { match } = this.props;

    try {
      const response = await fetchGroup(match.params.groupName);
      const brand = Array.isArray(response)
        ? response.find(item => item.name === match.params.groupName)
        : response;

      if (!brand || !brand.id) {
        throw new Error('Brand not found in response');
      }

      this.setState({ brandId: brand.id, sourceChannelId: brand.channelId });
    } catch (error) {
      console.error(
        `Failed to load brand id for group ${match.params.groupName}`,
        error
      );
    }
  };

  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleEditGroupClick = () => {
    const { match } = this.props;
    this.handleClose();
    this.props.history.push(`${match.url}/edit`);
  };

  handleCopyToChannelClick = () => {
    this.handleClose();
    this.setState({ copyMoveModalOpen: true });
  };

  handleCopyConfirm = (targetChannelId, newName, copyContent) => {
    const { brandId } = this.state;
    this.props.copyGFCBrand(brandId, targetChannelId, newName, copyContent);
  };

  handleMoveConfirm = targetChannelId => {
    const { brandId } = this.state;
    this.props.moveGFCBrand(brandId, targetChannelId);
  };

  handleCopyModalClose = () => {
    if (!this.props.copying && !this.props.moving) {
      this.setState({ copyMoveModalOpen: false });
    }
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleImportClick = () => {
    this.setState({ importModalOpen: true, importErrors: [] });
  };

  handleImportCancel = () => {
    if (!this.state.importing) {
      this.setState({ importModalOpen: false, importErrors: [] });
    }
  };

  handleImportConfirm = async (file, existingStrategy) => {
    const { match } = this.props;

    this.setState({ importing: true, importErrors: [] });
    try {
      const result = await importContentCsv(
        match.params.groupName,
        file,
        existingStrategy
      );
      this.setState({ importing: false, importModalOpen: false });
      this.props.enqueueSnackbar({
        message: `Imported ${result.created} created, ${
          result.updated
        } updated, ${result.ignored} skipped.`,
        options: {
          variant: result.created + result.updated > 0 ? 'success' : 'warning'
        }
      });
      await this.initialise();
    } catch (error) {
      const importErrors = error.errors || [];
      this.setState({ importing: false, importErrors });
      if (importErrors.length === 0) {
        this.props.enqueueSnackbar({
          message: error.message || 'Failed to import contents.',
          options: { variant: 'error' }
        });
      }
    }
  };

  entitiesToArray = entities => {
    return entities.map(entity => this.entityToArray(entity));
  };

  entityToArray = entity => {
    const { systemName, contentId, notes = '' } = entity;
    return [
      systemName,
      parseInt(contentId, BASE_10_RADIX),
      notes ? notes : '',
      contentId
    ];
  };

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            maxWidth: '500px'
          }
        }
      }
    });

  render() {
    const { match, copying, moving } = this.props;
    const {
      error,
      items,
      anchorEl,
      copyMoveModalOpen,
      brandId,
      sourceChannelId,
      importModalOpen,
      importing,
      importErrors
    } = this.state;

    const title = (
      <div>
        <h2 style={styles.header}>
          {match.params.groupName}
          <IconButton
            id="group-drawer"
            aria-owns={anchorEl ? 'simple-menu' : null}
            aria-haspopup="true"
            onClick={this.handleMenuClick}
          >
            <MenuIcon />
          </IconButton>
        </h2>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          <MenuItem onClick={this.handleEditGroupClick} id="menu-edit-group">
            Edit Group
          </MenuItem>
          <MenuItem
            onClick={this.handleCopyToChannelClick}
            id="menu-copy-to-channel"
            disabled={!brandId}
          >
            Copy or Move to Channel
          </MenuItem>
        </Menu>
      </div>
    );

    if (!items) {
      return error ? <ErrorMessage /> : <Loading />;
    }

    const columns = [
      'Name',
      'Content Id',
      'Notes',
      {
        name: '',
        sort: false,
        filter: false,
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            return <RowOptions path={`${match.url}/${value}`} />;
          }
        }
      }
    ];
    const data = this.entitiesToArray(items);
    const options = {
      filterType: 'multiselect',
      viewColumns: false,
      selectableRows: false,
      rowsPerPage: 25,
      rowsPerPageOptions: [25, 50, 100]
    };

    return (
      <NavigationLayout>
        <div>
          <Header isTitle={true} isOperatorHome={false} isGroupHome={false} />
          <div style={styles.main}>
            <NavigateIcon
              to={`/channel/${match.params.channelId}/groups`}
              id="navigate-back-groups"
            />
            <DisplayAndCreate
              title={title}
              createButtonText="Create Content"
              extraActions={
                <Button
                  id="import-contents-btn"
                  onClick={this.handleImportClick}
                  variant="outlined"
                  color="primary"
                >
                  Import Contents
                </Button>
              }
              {...this.props}
            >
              {(items.length !== 0 && (
                <MuiThemeProvider theme={this.getMuiTheme()}>
                  <MUIDataTable
                    data={data}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              )) || <ErrorMessage message={noContent} />}
            </DisplayAndCreate>
          </div>
          <CopyMoveToChannelModal
            open={copyMoveModalOpen}
            groupName={match.params.groupName}
            sourceChannelId={sourceChannelId}
            copying={copying}
            moving={moving}
            onConfirmCopy={this.handleCopyConfirm}
            onConfirmMove={this.handleMoveConfirm}
            onCancel={this.handleCopyModalClose}
          />
          <ImportContentModal
            open={importModalOpen}
            importing={importing}
            errors={importErrors}
            onConfirm={this.handleImportConfirm}
            onCancel={this.handleImportCancel}
          />
        </div>
      </NavigationLayout>
    );
  }
}

const mapStateToProps = state => ({
  copying: state.group.copying,
  copySuccess: state.group.copySuccess,
  copyError: state.group.copyError,
  moving: state.group.moving,
  moveSuccess: state.group.moveSuccess,
  moveError: state.group.moveError
});

const mapDispatchToProps = dispatch => ({
  copyGFCBrand: (brandId, targetChannelId, newName, copyContent) =>
    dispatch(copyGFCBrand(brandId, targetChannelId, newName, copyContent)),
  moveGFCBrand: (brandId, targetChannelId) =>
    dispatch(moveGFCBrand(brandId, targetChannelId)),
  enqueueSnackbar: notification => dispatch(enqueueSnackbar(notification))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupContent);
